<template>
    <main class="maintenance-page">
        <h1>Сайт на технических работах</h1>
    </main>
</template>

<style scoped>
.maintenance-page {
    display: flex;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: #fff;
    color: #000;
    text-align: center;
}

h1 {
    margin: 0;
    font-size: clamp(24px, 4vw, 48px);
    font-weight: 600;
}
</style>
